import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';

@Injectable()
export class CanActivateCommunitySettingsGuard implements CanActivate {
    constructor(
        private commonDataService: CommonDataService,
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const community = this.authenticationService.community;
        const allowedUrls = ['tags', 'reply-templates', 'widgets'];

        if (
            this.commonDataService.user.isAdmin ||
            this.commonDataService.user.isSystemAdmin ||
            (this.commonDataService.user.role === UserRole.manager &&
                allowedUrls.some((urlName: string) => {
                    return state.url.includes(urlName);
                }))
        ) {
            return of(true);
        }

        this.router.navigate([`/${community}/403`], { skipLocationChange: true });
        return of(false);
    }
}
